import { useEffect, useState } from 'react'

import { fetchHelpArticles } from '../service/helpApi'
import type { HelpArticleSummary } from '../types'

// Loads the article catalog once (cached in the service) and exposes it for
// screen-aware suggestions.
export function useHelpArticles(): {
  articles: HelpArticleSummary[]
  failed: boolean
} {
  const [articles, setArticles] = useState<HelpArticleSummary[]>([])
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let active = true
    fetchHelpArticles()
      .then((loaded) => {
        if (active) setArticles(loaded)
      })
      .catch(() => {
        if (active) setFailed(true)
      })
    return () => {
      active = false
    }
  }, [])

  return { articles, failed }
}
